import React, { useState } from "react";
import "./Economic_Calendar.css";
import {
  faArrowDown,
  faArrowUp,
  faCloudArrowUp,
  faMagnifyingGlass,
  faPlus,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Accordion, Form, InputGroup, Table } from "react-bootstrap";
import Select from "react-select";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

const Economic_Calendar = ({ onClose }) => {
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const [activeKey, setActiveKey] = useState(null);
  const [activeStatus, setActiveStatus] = useState("Actual");

  const economicEvents = [
    {
      time: "10:00 AM",
      title: "New Yuan Loans",
      values: ["3.6T", "3.6T", "3.6T"],
      description:
        "In China, new yuan loans refer to financial institutions' Renminbi credit funds balance sheet. They represent more than four-fifths of all loans.",
      currency: "CNY",
    },
    {
      time: "12:00 PM",
      title: "Interest Rate Decision",
      values: ["4.5%", "4.7%", "4.3%"],
      description:
        "Central bank decides benchmark interest rates. It affects currency valuation directly.",
      currency: "USD",
    },
    {
      time: "02:30 PM",
      title: "Unemployment Rate",
      values: ["5.1%", "5.0%", "5.2%"],
      description:
        "Measures the percentage of the total workforce that is unemployed and actively seeking employment.",
      currency: "EUR",
    },
    {
      time: "04:00 PM",
      title: "Retail Sales MoM",
      values: ["2.4%", "2.1%", "2.7%"],
      description:
        "Shows the monthly change in the total value of sales at the retail level.",
      currency: "GBP",
    },
    {
      time: "10:00 AM",
      title: "New Yuan Loans",
      values: ["3.6T", "3.6T", "3.6T"],
      description:
        "In China, new yuan loans refer to financial institutions' Renminbi credit funds balance sheet. They represent more than four-fifths of all loans.",
      currency: "CNY",
    },
    {
      time: "12:00 PM",
      title: "Interest Rate Decision",
      values: ["4.5%", "4.7%", "4.3%"],
      description:
        "Central bank decides benchmark interest rates. It affects currency valuation directly.",
      currency: "USD",
    },
    {
      time: "02:30 PM",
      title: "Unemployment Rate",
      values: ["5.1%", "5.0%", "5.2%"],
      description:
        "Measures the percentage of the total workforce that is unemployed and actively seeking employment.",
      currency: "EUR",
    },
    {
      time: "04:00 PM",
      title: "Retail Sales MoM",
      values: ["2.4%", "2.1%", "2.7%"],
      description:
        "Shows the monthly change in the total value of sales at the retail level.",
      currency: "GBP",
    },
  ];

  return (
    <section className="Economic_Calendar Instruments">
      <div className="heading_part">
        <p className="heading_name">Economic Calendar</p>
        <div className="img_holder" onClick={onClose}>
          <img src="/assets/images/trade/close.png" className="close_img" />
        </div>
      </div>

      <div className="inputs_div">
        <div className="first_input_div">
          <div className="left_input">
            <InputGroup className="gray_input_group">
              <Form.Control
                placeholder="Search"
                type="text"
                className="file_input"
              />
              <InputGroup.Text id="basic-addon2" className="search_icon_holder">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </InputGroup.Text>
            </InputGroup>
          </div>

          <div className="plus_icon_holder">
            <FontAwesomeIcon icon={faPlus} className="plus_icon" />
          </div>
        </div>
        <div className="second_input_div">
          <Select
            options={options}
            className="gray_select"
            placeholder="All Countries"
          />
        </div>
      </div>

      <div className="black_tabs_div">
        <div className="black_tabs_holder">
          <Swiper
            spaceBetween={20}
            breakpoints={{
              0: {
                slidesPerView: 3,
              },

              992: {
                slidesPerView: 2.4,
                spaceBetween: 10,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              1400: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
            }}
            className="mySwiper"
          >
            <SwiperSlide>
              <button
                className={`status_btn ${
                  activeStatus === "Actual" ? "active" : ""
                }`}
                onClick={() => setActiveStatus("Actual")}
                type="button"
              >
                Actual
              </button>
            </SwiperSlide>

            <SwiperSlide>
              <button
                className={`status_btn ${
                  activeStatus === "Forecast" ? "active" : ""
                }`}
                onClick={() => setActiveStatus("Forecast")}
                type="button"
              >
                Forecast
              </button>
            </SwiperSlide>

            <SwiperSlide>
              <button
                className={`status_btn ${
                  activeStatus === "Previous" ? "active" : ""
                }`}
                onClick={() => setActiveStatus("Previous")}
                type="button"
              >
                Previous
              </button>
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="tab_container">
          <div className="tab_pane">
            <div className="date_div">
              <p className="date_text">15 April</p>
            </div>

            <div className="accordion_holder">
              {activeStatus === "Actual" && (
                <Accordion
                  activeKey={activeKey}
                  onSelect={(key) => setActiveKey(key)}
                >
                  {economicEvents.map((item, idx) => (
                    <Accordion.Item eventKey={idx.toString()} key={idx}>
                      <Accordion.Header>
                        <div className="data_holder_container">
                          <div className="text_div">
                            <p className="time_text">{item.time}</p>

                            <div className="right_side">
                              <p className="location_text">{item.title}</p>
                              <div className="custom_toggle_icon">
                                <FontAwesomeIcon
                                  icon={
                                    activeKey === idx.toString()
                                      ? faSortUp
                                      : faSortDown
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          <div className="value_label_main_div">
                            <div className="row">
                              {item.values.map((val, valIdx) => (
                                <div className="col-4" key={valIdx}>
                                  <div
                                    className={`value_holder ${
                                      valIdx < 2 ? "border_right" : ""
                                    }`}
                                  >
                                    <p className="label">{item.currency}</p>
                                    <p className="label">{val}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <p className="descn">{item.description}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              )}

              {activeStatus === "Forecast" && (
                <Accordion
                  activeKey={activeKey}
                  onSelect={(key) => setActiveKey(key)}
                >
                  {economicEvents.map((item, idx) => (
                    <Accordion.Item eventKey={idx.toString()} key={idx}>
                      <Accordion.Header>
                        <div className="data_holder_container">
                          <div className="text_div">
                            <p className="time_text">{item.time}</p>

                            <div className="right_side">
                              <p className="location_text">{item.title}</p>
                              <div className="custom_toggle_icon">
                                <FontAwesomeIcon
                                  icon={
                                    activeKey === idx.toString()
                                      ? faSortUp
                                      : faSortDown
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          <div className="value_label_main_div">
                            <div className="row">
                              {item.values.map((val, valIdx) => (
                                <div className="col-4" key={valIdx}>
                                  <div
                                    className={`value_holder ${
                                      valIdx < 2 ? "border_right" : ""
                                    }`}
                                  >
                                    <p className="label">{item.currency}</p>
                                    <p className="label">{val}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <p className="descn">{item.description}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Economic_Calendar;
